<template>
  <div id="wt-form-left"  :class="{'hide-header': hideHeader}">
    <div id="wt-form-left-header"  v-if="!hideHeader">
      <div class="mt-1">
        <p class="p-2">
          <i class="fas fa-filter ml-2"></i>
          FILTERS
        </p>
      </div>
      <div class="mr-2">
        <b-button pill size="sm" variant="light" @click="filter" v-if="!viewFind">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </div>

    <!-- Slot Default -->
    <div id="wt-form-left-main">
      <slot name="default"></slot>
    </div>
    <!-- Slot Footer -->
    <div id="wt-form-left-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "wtFormLeft",
  props: {
    hideHeader: Boolean 
  },
  computed: {
    showFilter() {
      return this.$store.state.toolbars.showFilter;
    },
    viewFind() {
      return this.$store.state.layout.viewFind;
    }
  },
  methods:{
    filter() {
      this.$store.commit("setShowFilter");
    },
  },
} 
</script>